<template>
  <div id="page">
    <van-notice-bar
      left-icon="volume-o"
      :scrollable="false"
      :text="noticeText"
    ></van-notice-bar>

    <div class="indexPage">
      <div v-on:click="openlcukly" class="mockTap"></div>

      <div class="prize bounce-in-top" v-show="show">
        <div class="prize-box">
          <img class="prize-img" src="../assets/pond-success.png" alt="" />
          <div class="prize-msg">
            <span
              v-if="currentOpen.Order == 3"
              style="
                position: absolute;
                font-size: 3.5vw;
                top: 287px;
                left: 23px;
                z-index: 9999;
              "
              >{{ sdName }}</span
            >
            <p class="prize-msg-text">{{ currentOpen.TextDesc }}</p>
            <img class="prize-msg-img" :src="currentOpen.url" alt="" />
            <!-- <div
              class="prize-msg-detail"
              v-for="(item, index) in openList"
              v-bind:key="index"
            >
              <p class="prize-msg-text">{{ item.TextDesc }}</p>
              <van-button
                type="default"
                color="#ff5c5c"
                v-if="item.ViewType > 0"
                @click="viewprize(item.ViewType)"
                size="mini"
                >查看</van-button
              >
            </div> -->
          </div>
          <div class="continue" v-on:click="close">{{ btnText }}</div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { Swipe, SwipeItem, Button, Toast } from "vant";
import AppVue from "../App.vue";
export default {
  data() {
    return {
      processNum: 0,
      drawChance: 0,
      noticeText: "",
      show: false,
      currentIndex: 0,
      currentOpen: {},
      btnText: "继续开启",
      openList: [{}],
      sdName: "",
    };
  },
  created() {
    console.log(this.$route.params.period);
    this.getProcessNum();
  },
  methods: {
    close() {
      var currentIndex = this.currentIndex;
      var length = this.openList.length;
      if (this.btnText == "关闭") {
        this.show = !this.show;
        return;
      }
      if (currentIndex < length) {
        var i = currentIndex + 1;
        this.currentOpen = this.openList[i];
        this.currentIndex = i;
      }

      currentIndex = this.currentIndex;
      if (currentIndex == length - 1) {
        this.btnText = "关闭";
      }
    },
    openlcukly() {
      var that = this;
      Toast.loading({
        duration: 0,
        message: "开启中...",
        forbidClick: true,
        loadingType: "spinner",
      });
      this.openList = [];
      this.currentIndex = 0;
      this.currentOpen = {};
      this.btnText = "继续开启";
      that.$http.get("SDWorker/LucklyDraw2021_3").then((res1) => {
        console.log(res1);
        if (res1.data.Msg != "success") {
          return that.$toast.fail(res1.data);
        } else {
          that.openList = res1.data.ListData;
          that.openList.forEach(function (value, index) {
            value.url = that.getImgUrlByOrder(value.Order);
          });
          that.currentOpen = that.openList[0];
          that.show = !that.show;
        }
        that.getProcessNum();
        Toast.clear();
      });
    },
    getProcessNum() {
      var that = this;
      that.$http.get("SDWorker/GetSdworkerProcessNum").then((res) => {
        that.processNum = res.data.Data.ProcessNum;
        that.drawChance = res.data.Data.DrawChance;
        var text = "您当前累计带单 " + that.processNum;
        if (res.data.Data.DrawChance > 0) {
          text = text + " ,还可开启 " + that.drawChance + " 次福袋大奖";
        }
        that.sdName = res.data.Data.SDWorkerName;
        that.noticeText = text;
      });
    },
    viewprize(type) {
      console.log(type);
      var name = this.sdName;
      this.$router.push({
        name: "DrawShare",
        params: { period: 3, index: type, name: name },
      });
    },
    getImgUrlByOrder(value) {
      // console.log(value);

      if (value == 1) {
        return require("../assets/draw3/coin.png");
      }
      if (value == 2) {
        return require("../assets/draw3/基金会会员.png");
      }

      if (value == 3) {
        return require("../assets/draw3/捐赠证书2.jpg");
      }

      if (value == 4) {
        return require("../assets/draw3/天力福袋2.jpg");
      }

      if (value == 5) {
        return require("../assets/draw3/年货礼包2.jpg");
      }

      if (value == 6) {
        return require("../assets/draw3/旺旺大礼包2.jpg");
      }

      if (value == 7) {
        return require("../assets/draw3/年货礼包and旺旺大礼包.jpg");
      }
    },
  },
  components: {
    [Swipe.name]: Swipe,
    [SwipeItem.name]: SwipeItem,
    [Button.name]: Button,
    [Toast.name]: Toast,
  },
};
</script>
<style scoped>
html {
  background: #f12416;
}
#page {
  width: 100%;
  height: 100%;
}
.indexPage {
  width: 100%;
  height: 100%;
  background-image: url("../assets/draw3/index.jpg");

  background-size: cover;
  background-repeat: no-repeat;
  background-position: center;
  display: flex;
  align-content: space-around;
  justify-content: center;
  flex-wrap: wrap;
}
.mockTap {
  width: 280px;
  height: 280px;
  padding-top: 70px;
}
.step {
  z-index: 999;
}

.bounce-in-top {
  -webkit-animation: bounce-in-top 1.2s ease-in both;
  animation: bounce-in-top 1.2s ease-in both;
}
/* ----------------------------------------------
 * Generated by Animista on 2021-9-5 1:36:2
 * Licensed under FreeBSD License.
 * See http://animista.net/license for more info. 
 * w: http://animista.net, t: @cssanimista
 * ---------------------------------------------- */

/**
 * ----------------------------------------
 * animation bounce-in-top
 * ----------------------------------------
 */
@-webkit-keyframes bounce-in-top {
  0% {
    -webkit-transform: translateY(-500px);
    transform: translateY(-500px);
    -webkit-animation-timing-function: ease-in;
    animation-timing-function: ease-in;
    opacity: 0;
  }
  38% {
    -webkit-transform: translateY(0);
    transform: translateY(0);
    -webkit-animation-timing-function: ease-out;
    animation-timing-function: ease-out;
    opacity: 1;
  }
  55% {
    -webkit-transform: translateY(-65px);
    transform: translateY(-65px);
    -webkit-animation-timing-function: ease-in;
    animation-timing-function: ease-in;
  }
  72% {
    -webkit-transform: translateY(0);
    transform: translateY(0);
    -webkit-animation-timing-function: ease-out;
    animation-timing-function: ease-out;
  }
  81% {
    -webkit-transform: translateY(-28px);
    transform: translateY(-28px);
    -webkit-animation-timing-function: ease-in;
    animation-timing-function: ease-in;
  }
  90% {
    -webkit-transform: translateY(0);
    transform: translateY(0);
    -webkit-animation-timing-function: ease-out;
    animation-timing-function: ease-out;
  }
  95% {
    -webkit-transform: translateY(-8px);
    transform: translateY(-8px);
    -webkit-animation-timing-function: ease-in;
    animation-timing-function: ease-in;
  }
  100% {
    -webkit-transform: translateY(0);
    transform: translateY(0);
    -webkit-animation-timing-function: ease-out;
    animation-timing-function: ease-out;
  }
}
@keyframes bounce-in-top {
  0% {
    -webkit-transform: translateY(-500px);
    transform: translateY(-500px);
    -webkit-animation-timing-function: ease-in;
    animation-timing-function: ease-in;
    opacity: 0;
  }
  38% {
    -webkit-transform: translateY(0);
    transform: translateY(0);
    -webkit-animation-timing-function: ease-out;
    animation-timing-function: ease-out;
    opacity: 1;
  }
  55% {
    -webkit-transform: translateY(-65px);
    transform: translateY(-65px);
    -webkit-animation-timing-function: ease-in;
    animation-timing-function: ease-in;
  }
  72% {
    -webkit-transform: translateY(0);
    transform: translateY(0);
    -webkit-animation-timing-function: ease-out;
    animation-timing-function: ease-out;
  }
  81% {
    -webkit-transform: translateY(-28px);
    transform: translateY(-28px);
    -webkit-animation-timing-function: ease-in;
    animation-timing-function: ease-in;
  }
  90% {
    -webkit-transform: translateY(0);
    transform: translateY(0);
    -webkit-animation-timing-function: ease-out;
    animation-timing-function: ease-out;
  }
  95% {
    -webkit-transform: translateY(-8px);
    transform: translateY(-8px);
    -webkit-animation-timing-function: ease-in;
    animation-timing-function: ease-in;
  }
  100% {
    -webkit-transform: translateY(0);
    transform: translateY(0);
    -webkit-animation-timing-function: ease-out;
    animation-timing-function: ease-out;
  }
}

.prize {
  background: rgba(0, 0, 0, 0.25);
  position: fixed;
  left: 0;
  top: 0;
  width: 100vw;
  height: 100vh;
  z-index: 1;
  display: -webkit-box;
  display: -webkit-flex;
  display: flex;
  -webkit-box-align: center;
  -ms-flex-align: center;
  -ms-grid-row-align: center;
  align-items: center;
  z-index: 100;
  flex-direction: column;
  justify-content: flex-start;
}
.prize-box {
  margin: 0 auto;
  position: relative;
  display: flex;
  align-items: center;
  flex-direction: column;
  padding-top: 10px;
}
.prize-img {
  width: 80vw;
  max-height: 200px;
  z-index: 8;
  /* max-width: 300px; */
}
.prize-img2 {
  width: 100vw;
  max-height: 120px;
  max-width: 375px;
}
.prize-msg {
  margin-top: -10px;
  width: 81vw;
  max-width: 294.5px;
  text-align: center;
  background: #ffffff;
  padding-bottom: 16px;
  font-size: 13pt;
  border-radius: 10px;
  padding: 10px;
}
.prize-msg-img {
  width: 78.5vw;
  max-width: 80vw;
  max-height: 70vw;
  border-radius: 12px;
}
.prize_name {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.prize-msg-detail {
  display: flex;
  justify-content: center;
  align-items: center;
}
.prize-msg-text {
  padding-right: 5px;
  margin: 8px;
}
.continue {
  width: 214px;
  height: 33px;
  margin: 10px;
  background: #ff5c5c;
  line-height: 35px;
  color: #ffffff;
  border-radius: 20px;
}
</style>